import { ContentSectionContainer, fetchRoute } from "@cakemail-org/ui-components-v2"
import { Route, Routes } from "react-router-dom"
import { ERoutes } from "../../utils/url"
import ContactsListing from "./containers/listing"
import { ContactsContext } from "./context"
import "./styles.scss"
import { TContacts } from "./types"

export function Contacts({ subRoute }: TContacts) {
    return <ContentSectionContainer className={`contactsContainer ${subRoute ? "subRoute" : ""}`}>
        <ContactsContext.Provider value={{}}>
            <Routes>
                <Route index path={fetchRoute({ route: ERoutes.contacts })} element={<ContactsListing />} />

                <Route index path={"/"} element={<ContactsListing />} />
            </Routes>
        </ContactsContext.Provider >
    </ContentSectionContainer >
}